import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineClose } from "react-icons/ai";
import { savePartnerInfo } from "../../Redux/Redux-slices/partnerInfoSlice";
import { useDispatch } from "react-redux";
import { useNotification } from "../../contextApi/NotificationProvider";
import { useNavigate } from "react-router-dom";

export default function ModalForm({ isOpen, onClose }) {
  const dispatch = useDispatch();
  const navigate=useNavigate()

  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = async (data) => {

    setLoading(true);

    const payload = {
      full_name: data.fullName,
      email: data.email,
      mobile_number: data.mobile,
      country: data.country,
      company_name: data.companyName || "",
      company_industry: data.companyIndustry || "",
      reason: data.reason,
      has_clients: data.hasClients === "yes" ? "Yes" : "No",
      start_time: data.timeline,
      aware_of_investment: data.investmentAcknowledged === "yes",
    };

    try {
      const resultAction = await dispatch(savePartnerInfo(payload));

      if (resultAction.meta.requestStatus === "fulfilled") {
        const message =
          resultAction.payload?.message ||
          "Your request was submitted successfully.";
        // showNotification(message, "success", 8000);
        navigate("/partner-with-us/thank-you")
        reset()
        onClose();
      } else {
        const errorMsg =
          resultAction.payload?.message || "Something went wrong.";
        showNotification(errorMsg, "error", 8000);
        reset()
      }
    } catch (err) {
      showNotification("Failed to submit.", "error", 8000);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const inputClass =
    "w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-violet-600";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
      <div className="bg-white rounded-2xl shadow-2xl px-14 max-md:px-4 py-8 w-full max-w-3xl relative max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-violet-600 transition"
        >
          <AiOutlineClose size={24} />
        </button>

        <h2 className="text-xl  mb-6 border-b  pb-2 text-center font-bold bg-gradient-to-r from-[#7f56e1] to-[#2fd7d8] text-transparent bg-clip-text">
          Please Fill the Details
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          {/* Grid - Row 1 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="fullName" className="block font-medium mb-1">
                Full Name <span className="text-red-600">*</span>
              </label>
              <input
                id="fullName"
                {...register("fullName", {
                  required: "Full name is required.",
                })}
                className={inputClass}
              />
              {errors.fullName && (
                <p className="text-red-500 text-sm">
                  {errors.fullName.message}
                </p>
              )}
            </div>

            <div>
              <label htmlFor="email" className="block font-medium mb-1">
                Email ID <span className="text-red-600">*</span>
              </label>
              <input
                type="email"
                id="email"
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Enter a valid email address.",
                  },
                })}
                className={inputClass}
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email.message}</p>
              )}
            </div>
          </div>

          {/* Grid - Row 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="mobile" className="block font-medium mb-1">
                Mobile Number <span className="text-red-600">*</span>
              </label>
              <input
                type="tel"
                id="mobile"
                {...register("mobile", {
                  required: "Mobile number is required.",
                  minLength: {
                    value: 10,
                    message: "Minimum 10 digits required.",
                  },
                })}
                className={inputClass}
              />
              {errors.mobile && (
                <p className="text-red-500 text-sm">{errors.mobile.message}</p>
              )}
            </div>

            <div>
              <label htmlFor="country" className="block font-medium mb-1">
                Country Name <span className="text-red-600">*</span>
              </label>
              <input
                id="country"
                {...register("country", { required: "Country is required." })}
                className={inputClass}
              />
              {errors.country && (
                <p className="text-red-500 text-sm">{errors.country.message}</p>
              )}
            </div>
          </div>

          {/* Grid - Row 3 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="companyName" className="block font-medium mb-1">
                Company Name{" "}
                <span className="text-gray-600 px-1 text-sm">
                  (if applicable)
                </span>
              </label>
              <input
                id="companyName"
                {...register("companyName")}
                className={inputClass}
              />
            </div>

            <div>
              <label
                htmlFor="companyIndustry"
                className="block font-medium mb-1"
              >
                Company Industry{" "}
                <span className="text-gray-600 px-1 text-sm">
                  (if applicable)
                </span>
              </label>
              <input
                id="companyIndustry"
                {...register("companyIndustry")}
                className={inputClass}
              />
            </div>
          </div>

          <div>
            <label htmlFor="reason" className="block font-medium mb-1">
              Why do you want to start your AI-Powered Personality Assessment
              Business? <span className="text-red-600">*</span>
            </label>
            <textarea
              id="reason"
              {...register("reason", { required: "This field is required." })}
              className={inputClass}
              rows={5}
            ></textarea>
            {errors.reason && (
              <p className="text-red-500 text-sm">{errors.reason.message}</p>
            )}
          </div>

          <div>
            <p className="font-medium mb-1">
              Do you have potential ready clients? <span className="text-red-600">*</span>
            </p>
            <div className="flex space-x-6">
              <label className="flex items-center space-x-2">
                <input type="radio" value="yes" {...register("hasClients")} />
                <span>Yes</span>
              </label>

              <label className="flex items-center space-x-2">
                <input type="radio" value="no" {...register("hasClients")} />
                <span>No</span>
              </label>
            </div>
          </div>

          <div>
            <label htmlFor="timeline" className="block font-medium mb-1">
              How soon do you want to start your own platform? <span className="text-red-600">*</span>
            </label>
            <select
              id="timeline"
              {...register("timeline", {
                required: "Please select a timeline.",
              })}
              className={inputClass}
            >
              <option value="">Select</option>
              <option value="Immediately">Immediately</option>
              <option value="30 days">30 days</option>
              <option value="60 days">60 days</option>
              <option value="90 days">90 days</option>
            </select>
            {errors.timeline && (
              <p className="text-red-500 text-sm">{errors.timeline.message}</p>
            )}
          </div>

          <div>
            <p className="font-medium mb-1">
              I am aware this requires an Investment of US $2,000 <span className="text-red-600">*</span>
            </p>
            <div className="flex space-x-6">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="yes"
                  {...register("investmentAcknowledged", {
                    required: "Acknowledgement is required.",
                  })}
                />
                <span>Yes</span>
              </label>

              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="no"
                  {...register("investmentAcknowledged", {
                    required: "Acknowledgement is required.",
                  })}
                />
                <span>No</span>
              </label>
            </div>
            {errors.investmentAcknowledged && (
              <p className="text-red-500 text-sm mt-1">
                {errors.investmentAcknowledged.message}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div className="flex justify-center pt-4  max-auto">
            <button
              type="submit"
              disabled={loading}
              className={`px-24 py-2 rounded-lg text-white ${loading ? "bg-gray-400 cursor-not-allowed text-black" : "bg-violet-600 hover:bg-violet-700 font-bold"
                }`}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
